import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Wrench, User, LogOut } from "lucide-react";
import { cn } from "../lib/utils";

const LOGO = "https://static.prod-images.emergentagent.com/jobs/9aa213a6-9b93-496d-b454-969c7d67f960/images/80b5831e8eb35a7d67db619b6b98959a8312a899cbdbc39b43bf61ef5e0fcc19.png";

const TABS = [
  { to: "/engineer", label: "My Jobs", icon: Wrench },
  { to: "/engineer/profile", label: "Profile", icon: User },
];

export default function EngineerLayout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Top app bar */}
      <header
        className="sticky top-0 z-30 bg-white border-b border-border flex items-center justify-between px-4"
        style={{ paddingTop: "env(safe-area-inset-top)", height: "calc(56px + env(safe-area-inset-top))" }}
        data-testid="engineer-topbar"
      >
        <div className="flex items-center gap-2">
          <img src={LOGO} alt="RoSo" className="h-8 w-8 object-contain" />
          <div className="leading-none">
            <div className="font-heading font-black text-base">RoSo Field</div>
            <div className="label-caps text-muted-foreground" style={{ fontSize: "0.55rem" }}>
              {user?.name}
            </div>
          </div>
        </div>
        <button onClick={handleLogout} data-testid="engineer-logout" className="text-signal flex items-center gap-1 text-sm font-medium">
          <LogOut size={18} />
        </button>
      </header>

      {/* Content */}
      <main className="flex-1 pb-24">{children}</main>

      {/* Bottom tab nav */}
      <nav
        className="fixed bottom-0 inset-x-0 z-30 bg-white border-t border-border grid grid-cols-2"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        data-testid="engineer-bottom-nav"
      >
        {TABS.map((t) => {
          const active = location.pathname === t.to;
          const Icon = t.icon;
          return (
            <Link
              key={t.to}
              to={t.to}
              data-testid={`tab-${t.label.replace(/\s+/g, "-").toLowerCase()}`}
              className={cn(
                "flex flex-col items-center justify-center gap-1 py-3 transition-colors",
                active ? "text-klein" : "text-muted-foreground"
              )}
            >
              <Icon size={22} strokeWidth={active ? 2.3 : 1.8} />
              <span className="text-[11px] font-semibold">{t.label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
